import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Checkbox } from "rsuite";
import Modal from "@material-ui/core/Modal";
import React, { useState } from "react";
import { useStylesWellcome } from "./style";
import CloseIcon from "../../assets/images/clear.svg";
import TextField from "@material-ui/core/TextField";
import { useCopyAddress } from "../../hooks/copyAddress";
import { withTranslation } from "react-i18next";

const NewKeyPair = (props) => {
  const classes = useStylesWellcome();
  const {
    openKeyModal,
    handleCloseKeysModal,
    secretKeyCopy,
    publicKeyCopy,
    t,
  } = props;
  const [copyText, CopyContactAddress] = useCopyAddress();
  const [confirmCopy, setConfirmCopy] = useState(false);

  const copyConfirmHandler = (value, checked) => {
    setConfirmCopy(checked);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openKeyModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={openKeyModal}>
        <div className={`${classes.paper} ${"modalBg"}`}>
          <img
            alt="CloseIcon"
            className={!confirmCopy ? "ClearModalImg hidden" : "ClearModalImg"}
            src={CloseIcon}
            onClick={handleCloseKeysModal}
          />
          <h2 className="modalTitle" id="transition-modal-title">
            {t("Add_Account")}
          </h2>
          <div className="modalInput label-color flexWrap">
            <TextField
              label={t("Secret_Key")}
              value={secretKeyCopy}
              disabled={true}
            />
            <button
              className={
                copyText === secretKeyCopy
                  ? "copyIconBtn tooltip2 active"
                  : "copyIconBtn tooltip2"
              }
              onClick={(e) => CopyContactAddress(secretKeyCopy)}
            >
              <i
                className={
                  copyText === secretKeyCopy
                    ? "fa fa-clone active"
                    : "fa fa-clone"
                }
                aria-hidden="true"
              />
              <div className="tooltiptext2">
                <p>{t("Copied")}</p>
              </div>
            </button>
          </div>
          <div className="modalInput label-color flexWrap">
            <TextField
              label={t("Public_Key")}
              value={publicKeyCopy}
              disabled={true}
            />
            <button
              className={
                copyText === publicKeyCopy
                  ? "copyIconBtn tooltip2 active"
                  : "copyIconBtn tooltip2"
              }
              onClick={(e) => CopyContactAddress(publicKeyCopy)}
            >
              <i
                className={
                  copyText === publicKeyCopy
                    ? "fa fa-clone active"
                    : "fa fa-clone"
                }
                aria-hidden="true"
              />
              <div className="tooltiptext2">
                <p>{t("Copied")}</p>
              </div>
            </button>
          </div>
          <div className="wallet-note">
            <Checkbox onChange={copyConfirmHandler}>
              {t("Wallet_Note")}
            </Checkbox>
          </div>
          <div className="modal_footer">
            <button
              className="btn btn-default senderBtn"
              disabled={!confirmCopy}
              onClick={handleCloseKeysModal}
            >
              {t("Accept")}
            </button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default withTranslation()(NewKeyPair);
